import { render } from "./MyUpload.vue?vue&type=template&id=51a8eaae&scoped=true"
import script from "./MyUpload.vue?vue&type=script&lang=js"
export * from "./MyUpload.vue?vue&type=script&lang=js"

import "./MyUpload.vue?vue&type=style&index=0&id=51a8eaae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a8eaae"]])

export default __exports__